<template>
  <div class="container tzy-detail home_page1">
    <div class="detail_box">
      <div class="info_nav">
        <van-icon name="arrow-left" class="back" @click="goBack" />
        <div style="padding-left: 13%">{{ detail.name }}</div>
        <div style="padding: 0 10px; width: 50px"></div>
      </div>
      <div class="header_all">
        <div>
          <span class="m-r-5">{{ detail.userScore && detail.userScore.score }}分</span>
          <span class="m-r-5">{{ detail.userScore && detail.userScore.course }}</span>
          <span class="m-r-5">{{ detail.userScore && detail.userScore.bzType }}</span>
        </div>
        <div class="sbort" @click="handleSbort">快速排序</div>
      </div>
      <div class="cbw_all" v-if="detail.levelNums">
        <div class="tisi">
          <div class="cbw-li">
            <span class="tzy-chong-bg round rush"></span>
            <div>
              冲(<span>{{ detail.levelNums["冲"] }}</span>)
            </div>
          </div>
        </div>
        <!--./tisi-->
        <div class="tisi">
          <div class="cbw-li">
            <span class="tzy-chong-bg round stable"></span>
            <div>
              稳(<span>{{ detail.levelNums["稳"] }}</span>)
            </div>
          </div>
        </div>
        <!--./tisi-->
        <div class="tisi">
          <div class="cbw-li">
            <span class="tzy-chong-bg round protect"></span>
            <div>
              保(<span>{{ detail.levelNums["保"] }}</span>)
            </div>
          </div>
        </div>
        <!--./tisi-->
      </div>
    </div>
    <div class="table-content">
      <!--el-table。 表头（带排序）： 录取概率、 院校、2022年招生计划、录取人数差、历年、2022年、2021年、2020年、填报-->
      <!--专业组-->
      <div class="tzy-container" v-if="detail.listType && detail.listType == 3">
        <!-- <draggable
          v-model="tableData"
          :options="dragOptions"
          @end="onEnd"
          @move="onMove"
          @start="onStart"
        > -->
        <!-- 过度效果 -->
        <div class="h5-college-tr" v-for="(item, index) in tableData" :key="index">
          <div class="h5-major-tr flex" style="width: 100%">
            <div class="percent">
              <div class="probab" @click="handleRanking(item, index)">
                <div class="probab-logo">
                  <img data-v-05f84c54=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA8CAYAAADWibxkAAAAAXNSR0IArs4c6QAACVJJREFUaEPlW/+PXFUV/5yZ2RYxNgQIUUJIjF9CiBCDxFRsY4k2RqIERasNNvVPIPgDKDFZYyhFAatGjV/DUhBarBCN/aWaNmnZ7oKF0sKybUqsUFqRTvf77szcN++Y++Z9Ofe9e9+X2d1acH7YmX173733fM7nfM65583SxuPPLIDRIAAIfsRvwafwkvN6/Hci1Hq3584Rz0/m3Ml9ckUx4TJ8nPU7Hm049idFQKO3sd7iyRaSTZLYl9y6CZC4s8/xcgdpKJYammML5xR9dXxXAkDiTovn02wob6xhVFVgDGZK19jYVo0mf586qegr43+MAUjWSjMB6DHAHhImI5I4crLDCJVwLcO9JUMvXqo6MD4zHj37sqLbXn1KAaEGRPErBCGa2kXNCBgzdKIwskIT/DGZ17X58gxLuyYK17xwOt2ZxV8nTii69dWdWQCEEoioMBSiyLvlgQl5lRBHCKmFiVKhFhFOB6dPYWyhqeiLYzsCAAwPxh6yUTHrsSJjM+zICScZZvHqgjEZb7vCiWVWM/fMzNjRHMOC31X0hbEnRRZIC4vwgLEJd4xKYysDE9zsBt0aNhVYEEX26c4M9kz+Uy+m6POv/CEEwDRWCqJJ97RU9pB2akSFcJJ+MtZ0apJNmLPakd7b/uk3cLI92QNg/cuPK5AWQQu1w82X04FsKZPUDuUY4wLSCUxSVQlRtexDOKHDHp5uHkMXQYwo+qwGAGwWQgW0sm4oVzdSnioZThnmObXDAbAIp2iu8YUmDs+9FeU7RTcffSxkgK2wCCc2FNqmzOUMdGaOwji2GJgCoygrBRRhYPfEa5jzOwkAnzn6qALImQVy83s4aRHVM+GVkwWsZbZmDCe0KWOsbZ43OzMYmXlT5g1Fa48MBQywV3mhtw0PWUQwzjhi2Yo0Lz5rpFgQszKrXa5UuW/qX5jotkwAbjoyZJbCJeku9Cej87askRVSm4LnCanpolwWWLLSW505jM6e7sVBFA9aBFe/9IgCcW4WCNOzMNS1eaEPBpBVxy/VWSCB6cD0G5jqtoX3AxwUffKl34elcLJjG7o2r0pgXHVD5nopYFyi6gImxY5UeJzpzArlNzBQdOPh3ykKNcAleNlGib3wkfnBPJCUo7s8JJVpxrjGS2dpwmvvL/ie6f3elhTdcPi34VkgSXmFKisPxpk6vYRIplhgb7BUDyebzpxsTeFEayJrfATAx1/8TZgF7CITb8NxIMmGhgCgKt0rHnpMBmT33/I9jM6cDqs+CwaaAde/+GtxGqyQayMWlGBAOlGZKS+r/EW64WrJGRAQ8Mrc2zjrLdi9HzHgYy/8ymRAxmuu9FOc852hZNQVrjwugMnUIcUp8W01D1325r40A6499EsF6lWCGeERQRV81D84bI8F7xSnVauxQQUn78uOzwhnOD6u/KL1QkskXEbMx+sQFHcD1VfsFwNwzaFfKCbqtcVtIJQExuVtmVmqNDhsGSXtIrv+AOPzzWzOt0GhGfCRf/w8YIATgDQLcjwRs0TogwmA/M3x/KFCv9Bcrzf3mc4MTrVn8j2f+FrRhwIAZEusuAoLllomYKRXY4+XSpvAbFfheFHcS2g0Az74/M9iDeiZ3gsmM6f2rmfVV18RzbcYGPd4kwMhC4Jze7iuQyDT3DH3Byjfx7GFJryiuE8DcPXzP1Wkj8MB9VyKnL1epd/Xo2qFucX4tKG2ClH3+F9rTdirvbxg0Ay46rmfKLJkAUNgZOIWj87MYBG9/nB8VqSktEWSm4BTND76e5B94hfj9fY0ZrpRk6Nc+IfarujK57aFADg2Z3saFDCcpFOtzxNj2pZoaBixX2J8NPe/1SwmPHnGrwjA+0d/LLJAcW/NmtaMB6phfZDJFjkFVUrk8tNdMrip5tHMq/SKsNAhcMXow9YQcIpOiQxgb4GVqCgjIMP8FlNeGBLxdMJbwLnFGN/TGUWXjzyUqgPEUbewrWVpUwViXpxKXRpj6oBdOHVjQwOw6JcG4NKRB90ApKkdKkeZc7vBAkdqk+ZlvO1gwWS3jel+Yz6NmAbgktEHO2AMuPNzcpeUSatiFzLGjO7QxhDW4jQ52W1hrh+1d1FFA7Bq5Ec6f6QAsFO4TC1vE0lpqFvgkjXTwDAYk14LLb+7aNYbE2gRfO/IDztkZUC2N+DM+6Jn5orhImDSSTiaxwdjymsXn+z6gUYD8J6DD3QoZECpFCcEoIxgRaAV9/2TLBExwPN9TPsd6EpvWV4agJUHt1oZEGynz/xcBIyhJYZAJi5osxeUtstle1wJDgzfb2VAYVc21Qozv9gghTNB0VT6rOgFBSYA3cvrVDnU9EsPzYDG8JY4C2QyQYUDTCxuJXqEyTq9wXG8M6PFy+x1ARbHAAgNcGYMoxrLSVlVwyZ0uz7GeihoYfXrafd9IQM0AMYjs/QjtPzfA6JEPcJwMasOWHqE+vs62vAg1qMYOH/viurDW84ScNlSg2stlFKVpc7v593nMgSAptaAvQDWLTUARaG0TImtqhn7qPbslrtqhIeq3vluGO8zvk3YO3hJY+WKE1iGMLjAQWp67c6Hg1CtH7xvQ43pyVSIXuD7X9T22Cf+RvdT9+6MtWpgeMudAB7+PwBBK+9das13t6XrHjT2/+BzVKtvA9G1QdPvXfUiBvMY+907vbXf+1tkWtZIBjWevW8dEW1i4tsJtOqdjAODp4lpFzNv9z59777wAURsUr6X/zJ4cf2ygdsItIkY60GovyPAYHSZsKcG3t5pqmfwpcH5orRcbNeBwSsH6iu/Dp83g+j6CzBEdF11BDUaUt32DqwZ1F8JK3z1Fecrhrde53N3M0AbiegD/zswiJn5DMBP1Kg+1LnpnqOFFqcG9AVAPMfOr9UbV92wnpi/CcKXAVxcdQN9jp8H42kmesw79cIebHiq717Z4gCQuz/wwPsGyLsdqG0i4nUAyf+i69NOeRv7zLQP8LcrbuzCmrtLPgPPX3rpAJDr7N96daPGG2uEzQCuWURtoY8M4z77Q57feQJrv//6EiBpTLE8AIglBkbu/wR8/hZAGwi4oowBDPwH4J2o0SNq9XcOlbmn3zHLDkC8sb2DjfpFK26pM+5g4FYCXWRumvUTzj93CY93W53duHnQ8s3Gfs1033f+AJB72D24qnHpytXk46P6Mtdw3DvXHsEtg9NLb2L+jP8FLjmgzejvtrkAAAAASUVORK5CYII="
                    alt="" />
                </div>
                <h1>
                  {{ index + 1 }}
                </h1>
              </div>
              <div class="easy">
                {{ item.probability }}
                <span style="
                    font-size: 10px;
                    font-family: 'PingFang SC-Regular';
                    margin-left: -5px;
                  ">%</span>
              </div>
              <div class="tzy-chong-color three-frame">
                <span v-if="item.riskLevel == '冲'" style="color: #e9302d">
                  {{ item.riskLevel }}
                </span>
                <span v-if="item.riskLevel == '稳'" style="color: #ff9a02">
                  {{ item.riskLevel }}
                </span>
                <span v-if="item.riskLevel == '保'" style="color: #06c687">
                  {{ item.riskLevel }}
                </span>
              </div>
              <p>{{ item.riskDesc }}</p>
            </div>
            <div class="major">
              <div class="major-info">
                <p class="h5-major-tr_title mb6">
                  <a href="javascript:void(0)" class="f16 mt5"><span class="collegeNamePreview"
                      style="word-break: break-all">
                      {{ item.collegeName }}({{ item.collegeMajorGroupName }})
                    </span>

                    <!-- <p style="font-size: 14px;color: #000;font-weight: normal;">
                      ({{ item.city }} {{ item.collegeCode }})
                    </p> -->
                    <p style="font-size: 12px;color: #9b9b9b;font-weight: normal;display: none;">
                      <span v-if="item.subjectReview">学科评估 {{ item.subjectReview }}</span>
                      <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                    </p>
                  </a>
                </p>
              </div>
              <!---->
              <p class="mt5 mb4 fw500 majorNamePreview">
                {{ item.features }}
                <!-- {{ item.bzType }} -->
              </p>
              <p>
                {{ item.province }} {{ item.city }} / {{ item.categories }} /
                {{ item.natureType }}
                <template v-if="item.collegeRank">
                  / 排名{{ item.collegeRank }}
                </template>
              </p>
              <p class=" mb4">
                <!-- {{ item.year }}招生计划 {{ item.planNum1 }} -->
                <span class="mr10">
                  招生计划增减
                  <span class="pl6">{{ item.planNumDiff > 0 ? "+" : "" }}{{ item.planNumDiff }}
                  </span>
                </span>
                <span v-if="item.majors && item.majors[0].masterRate != ''">
                  保研率： {{ item.majors[0].masterRate }}
                </span>
              </p>
              <p>
                <span style="font-weight: 0">
                  代码
                  <span style="font-size: 14px;color: #000;">
                    {{ item.collegeMajorGroupCode }}
                  </span>
                </span>
              </p>
              <div class="history-content history-conent">
                <table>
                  <tr>
                    <th width="40">年份</th>
                    <th width="60">录取人数</th>
                    <th width="50">最低分</th>
                    <th>最低位次</th>
                  </tr>
                  <tr v-if="item.minScore1">
                    <td align="center">{{ item.majors && item.majors[0].year }}</td>
                    <td align="center">{{ item.planNum1 || "-" }}</td>
                    <td align="center">{{ item.minScore1 || "-" }}</td>
                    <td align="center">{{ item.minRank1 || "-" }}</td>
                  </tr>
                  <tr>
                    <td align="center">{{ item.majors && item.majors[0].year - 1 }}</td>
                    <td align="center">{{ item.planNum2 || "-" }}</td>
                    <td align="center">{{ item.minScore2 || "-" }}</td>
                    <td align="center">{{ item.minRank2 || "-" }}</td>
                  </tr>
                  <tr>
                    <td align="center">{{ item.majors && item.majors[0].year - 2 }}</td>
                    <td align="center">{{ item.planNum3 || "-" }}</td>
                    <td align="center">{{ item.minScore3 || "-" }}</td>
                    <td align="center">{{ item.minRank3 || "-" }}</td>
                  </tr>
                  <tr v-if="!(item.minScore1)">
                    <td align="center">{{ item.majors && item.majors[0].year - 3 }}</td>
                    <td align="center">{{ item.planNum4 || "-" }}</td>
                    <td align="center">{{ item.minScore4 || "-" }}</td>
                    <td align="center">{{ item.minRank4 || "-" }}</td>
                  </tr>
                </table>
              </div>

            </div>
            <div class="delete">
              <i class="icon-item el-icon-caret-top" @click="rank('up', item, index, 'listType3')"
                :style="index == 0 ? 'opacity: 0.3;' : 'opacity: 1;'"></i>
              <i class="icon-item el-icon-delete" @click="del(item, 'listType3')"></i>
              <i class="icon-item el-icon-caret-bottom"
                :style="index == tableData.length - 1 ? 'opacity: 0.3;' : 'opacity: 1;'"
                @click="rank('down', item, index, 'listType3')"></i>
            </div>
          </div>
          <!--专业-->
          <div class="h5-major-tr flex" style="width: 100%" v-for="(ele, i) in item.majors" :key="i">
            <div class="percent">
              <!-- <div class="probab">

              </div> -->
              <div class="easy" style="padding-top:2px">
                {{ ele.probability }}
                <span style="
                    font-size: 10px;
                    font-family: 'PingFang SC-Regular';
                    margin-left: -5px;
                  ">%</span>
              </div>
              <div class="tzy-chong-color three-frame">
                <span v-if="ele.riskLevel == '冲'" style="color: #e9302d">
                  {{ ele.riskLevel }}
                </span>
                <span v-if="ele.riskLevel == '稳'" style="color: #ff9a02">
                  {{ ele.riskLevel }}
                </span>
                <span v-if="ele.riskLevel == '保'" style="color: #06c687">
                  {{ ele.riskLevel }}
                </span>
              </div>
              <p>{{ ele.riskDesc }}</p>
            </div>
            <div class="major" style="margin-top: 0;padding-top: 0;">
              <div class="major-info">
                <a href="javascript:void(0)" class="f16 mt5">
                  <span class="collegeNamePreview" style="word-break: break-all;font-weight: 600;">
                    {{ ele.majorName }}
                  </span>
                  <p class="mb6" style="font-weight: normal;font-size: 12px;color: #666;line-height: 20px;">
                    <span class="pr10">
                      专业代码
                      <span style="font-size: 14px; color: #000;">{{ ele.majorEnrollCode }}</span>
                    </span><br />
                    <span class="mr10"> {{ ele.year }}年计划 {{ ele.planNum1 }}人 </span>
                    <span style="font-weight: normal">
                      {{ ele.learnYear }} ¥{{ ele.cost }}
                      <br />
                      <span class="mr10">
                        招生计划增减 <span class="pl6">{{ item.planNumDiff > 0 ? '+' : ''
                          }}{{ item.planNumDiff }}</span>
                      </span>
                      选科 {{ ele.chooseSubject }}
                    </span>
                  </p>
                </a>
              </div>
              <!---->
              <div class="history-content history-conent">
                <table>
                  <tr>
                    <th width="40">年份</th>
                    <th width="50">录取人数</th>
                    <th width="45">最低分</th>
                    <th width="65">最低位次</th>
                    <th>平均分</th>
                  </tr>
                  <tr v-if="ele.minScore1">
                    <td align="center">{{ ele.year }}</td>
                    <td align="center">{{ ele.planNum1 || "-" }}</td>
                    <td align="center">{{ ele.minScore1 || "-" }}</td>
                    <td align="center">{{ ele.minRank1 || "-" }}</td>
                    <td align="center">{{ ele.minAverag1 || "-" }}</td>
                  </tr>
                  <tr>
                    <td align="center">{{ ele.year - 1 }}</td>
                    <td align="center">{{ ele.planNum2 || "-" }}</td>
                    <td align="center">{{ ele.minScore2 || "-" }}</td>
                    <td align="center">{{ ele.minRank2 || "-" }}</td>
                    <td align="center">{{ ele.minAverag2 || "-" }}</td>
                  </tr>
                  <tr>
                    <td align="center">{{ ele.year - 2 }}</td>
                    <td align="center">{{ ele.planNum3 || "-" }}</td>
                    <td align="center">{{ ele.minScore3 || "-" }}</td>
                    <td align="center">{{ ele.minRank3 || "-" }}</td>
                    <td align="center">{{ ele.minAverag3 || "-" }}</td>
                  </tr>
                  <tr v-if="!(ele.minScore1)">
                    <td align="center">{{ ele.year - 3 }}</td>
                    <td align="center">{{ ele.planNum4 || "-" }}</td>
                    <td align="center">{{ ele.minScore4 || "-" }}</td>
                    <td align="center">{{ ele.minRank4 || "-" }}</td>
                    <td align="center">{{ ele.minAverag4 || "-" }}</td>
                  </tr>
                </table>
              </div>

            </div>
            <div class="delete">
              <i class="icon-item el-icon-caret-top" @click="rank('up', ele, i, 'listType3', index)"
                :style="i == 0 ? 'opacity: 0.3;' : 'opacity: 1;'"></i>
              <i class="icon-item el-icon-delete" @click="del(ele, 'listType3', index)"></i>
              <i class="icon-item el-icon-caret-bottom"
                :style="i == item.majors.length - 1 ? 'opacity: 0.3;' : 'opacity: 1;'"
                @click="rank('down', ele, i, 'listType3', index)"></i>
            </div>
          </div>
          <!--./end-->
        </div>
        <!-- </draggable> -->
      </div>
      <!--专业---->
      <div class="tzy-container" v-else>
        <!-- <draggable
          v-model="tableData"
          :options="dragOptions"
          @end="onEnd"
          @move="onMove"
          @start="onStart"
        > -->
        <!-- 过度效果 -->
        <div class="h5-college-tr" v-for="(item, index) in tableData" :key="index">
          <div class="h5-major-tr flex" style="width: 100%">
            <div class="percent">
              <div class="probab" @click="handleRanking(item, index)">
                <div class="probab-logo">
                  <img data-v-05f84c54=""
                    src="data:image/png;base64,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"
                    alt="" />
                </div>
                <h1>
                  {{ index + 1 }}
                </h1>
              </div>
              <div class="easy">
                {{ item.probability }}
                <span style="
                    font-size: 10px;
                    font-family: 'PingFang SC-Regular';
                    margin-left: -5px;
                  ">%</span>
              </div>
              <div class="tzy-chong-color three-frame">
                <span v-if="item.riskLevel == '冲'" style="color: #e9302d">
                  {{ item.riskLevel }}
                </span>
                <span v-if="item.riskLevel == '稳'" style="color: #ff9a02">
                  {{ item.riskLevel }}
                </span>
                <span v-if="item.riskLevel == '保'" style="color: #06c687">
                  {{ item.riskLevel }}
                </span>
              </div>
              <p>{{ item.riskDesc }}</p>
            </div>
            <div class="major">
              <div class="major-info">
                <p class="h5-major-tr_title mb6">
                  <a href="javascript:void(0)" class="f16 mt5">
                    <span class="collegeNamePreview" style="word-break: break-all">
                      {{ item.majorName }}
                    </span>
                    <!--10.注释专业-->
                    <!-- <section class="zy-remark">
                      {{ item.majorType }}
                    </section> -->
                    <p style="font-size: 12px; color: #9b9b9b; font-weight: normal">
                      <!-- <span v-if="item.subjectReview"
                                    >学科评估 {{ item.subjectReview }}</span
                                  > -->
                      <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                    </p>
                  </a>
                </p>
              </div>
              <!---->
              <p class="mb6 fw500 college-code">
                <b class="pr10"> 专业代码 {{ item.majorEnrollCode }} </b><br />
                <b class="mr10"> {{ item.year }}年计划 {{ item.planNum1 }}人 </b>
                <span style="font-weight: normal">
                  {{ item.learnYear }} ¥{{ item.cost }}
                  <br />
                  <span class="mr10">
                    招生计划增减<span class="pl6">{{ item.planNumDiff > 0 ? '+' : ''
                      }}{{ item.planNumDiff }}</span>
                  </span>
                  选科 {{ item.chooseSubject }}
                </span>
              </p>
              <div class="history-content history-conent">
                <table>
                  <tr>
                    <th width="40">年份</th>
                    <th width="60">录取人数</th>
                    <th width="50">最低分</th>
                    <th>最低位次</th>
                    <!-- <th>平均分</th> -->
                  </tr>
                  <tr v-if="item.minScore1">
                    <td align="center">{{ item.year }}</td>
                    <td align="center">{{ item.planNum1 || "-" }}</td>
                    <td align="center">{{ item.minScore1 || "-" }}</td>
                    <td align="center">{{ item.minRank1 || "-" }}</td>
                    <!-- <td align="center">{{ item.minAverage1 || "-" }}</td> -->
                  </tr>
                  <tr>
                    <td align="center">{{ item.year - 1 }}</td>
                    <td align="center">{{ item.planNum2 || "-" }}</td>
                    <td align="center">{{ item.minScore2 || "-" }}</td>
                    <td align="center">{{ item.minRank2 || "-" }}</td>
                    <!-- <td align="center">{{ item.minAverage2 || "-" }}</td> -->
                  </tr>
                  <tr>
                    <td align="center">{{ item.year - 2 }}</td>
                    <td align="center">{{ item.planNum3 || "-" }}</td>
                    <td align="center">{{ item.minScore3 || "-" }}</td>
                    <td align="center">{{ item.minRank3 || "-" }}</td>
                    <!-- <td align="center">{{ item.minAverage3 || "-" }}</td> -->
                  </tr>
                  <tr v-if="!(item.minScore1)">
                    <td align="center">{{ item.year - 3 }}</td>
                    <td align="center">{{ item.planNum4 || "-" }}</td>
                    <td align="center">{{ item.minScore4 || "-" }}</td>
                    <td align="center">{{ item.minRank4 || "-" }}</td>
                    <!-- <td align="center">{{ item.minAverage4 || "-" }}</td> -->
                  </tr>
                </table>
              </div>
              <p class="mt5 mb4 fw500 majorNamePreview">
                <span @click="viewCollegeDetail(scope.row)">{{ item.collegeName }}</span>
                {{ item.bzType }}
              </p>
              <p>
                {{ item.province }} {{ item.city }} / {{ item.categories }} /
                {{ item.natureType }} / 排名{{ item.collegeRank }}
              </p>
              <p v-if="item.masterRate && item.masterRate != ''">
                保研率： {{ item.masterRate }}
              </p>
              <p class="fw500 college-code">
                大学代码 {{ item.collegeEnrollCode }}
                <!-- <span class="mr10">{{ item.year }}年计划 {{ item.planNum1 }}人</span> -->
              </p>
            </div>
            <div class="delete">
              <i class="icon-item el-icon-caret-top" @click="rank('up', item, index)"
                :style="index == 0 ? 'opacity: 0.3;' : 'opacity: 1;'"></i>
              <i class="icon-item el-icon-delete" @click="del(item)"></i>
              <i class="icon-item el-icon-caret-bottom"
                :style="index == tableData.length - 1 ? 'opacity: 0.3;' : 'opacity: 1;'"
                @click="rank('down', item, index)"></i>
            </div>
          </div>
          <!---->
        </div>
        <!-- </draggable> -->
      </div>
    </div>
    <div class="foot-box van-row">
      <div class="recommendBtn-flex-flex">
        <button @click="download" class="recommend-btn recommend-btn1">下载</button>
        <button @click="edit" class="recommend-btn recommend-btn1">修改</button>
        <button @click="save" class="recommend-btn">保存</button>
      </div>
    </div>
    <van-popup v-model="rankShow" closeable close-icon-position="top-right" position="bottom"
      :style="{ maxHeight: '60vh', borderRadius: '10px 10px 0 0' }">
      <div class="major_title">
        <div class="title1">
          {{ rankData && rankData.majorName }}
        </div>
      </div>

      <div class="major_cont">
        <div class="tzy-container">
          <div class="num" v-for="(item, index) in tableData" :key="index" @click="setRanking(item, index)"
            :class="rankNum == index ? 'active' : ''">
            <span>
              {{ index + 1 }}
            </span>
            <!---->
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="saveShow" closeable close-icon-position="top-right" position="bottom"
      :style="{ borderRadius: '10px 10px 0 0' }">
      <div class="tip_box">
        <h6 class="tip_box_title"><i class="el-icon-warning"></i>重要提示：</h6>
        <div class="dataDescription">
          注：以上志愿表为模拟填报志愿表，正式填报请登录省考试院指定填报网站；<br />申明：智能推荐使用当年招生计划和参考历年录取数据的志愿模拟填报平台，参考数据均来自省考试院，正式填报过程中如遇到数据错误，请参阅省考试院发布的相关招生计划书籍或拨打客服热线。
        </div>
        <div class="tip_box_btn" @click="saveShow = !saveShow">我已知晓，同意</div>
      </div>
    </van-popup>
    <!--快速排序-->
    <van-popup v-model="sbortShow" closeable close-icon-position="top-right" position="bottom" :style="{
          maxHeight: '85vh',
          borderRadius: '10px 10px 0 0',
          overflow: 'hidden',
        }">
      <div class="sbort_header">
        <div class="sbort_box_title">
          <span class="fast-queue">快速排序</span>
          <sapn class="order">长按右侧 ☰ 拖拽调整顺序或点击序号快速排序</sapn>
        </div>
        <div class="popup-title">
          <div class="title title-rate" @click="handleSort('院校', soreType)">
            院校排名
            <div class="title-icon">
              <i class="el-icon-caret-top" :style="soreName == '院校' && soreType == 1 ? 'color:#910000' : ''"></i>
              <i class="el-icon-caret-bottom" :style="soreName == '院校' && soreType == 2 ? 'color:#910000' : ''"></i>
            </div>
          </div>

          <div class="title title-rate" v-for="(item, index) in detail.usePlan" :key="index"
            @click="handleSort('年份' + (index + 1), soreType)">
            <span>
              {{ detail.recentYears[index + 1] }} 年<br />
              <!-- <span class="fen"> {{ detail.scoreList["score" + (index + 1)] }} 分 </span> -->
            </span>
            <div class="title-icon">
              <i class="el-icon-caret-top" :style="soreName == '年份' + (index + 1) && soreType == 1 ? 'color:#910000' : ''
          "></i>
              <i class="el-icon-caret-bottom" :style="soreName == '年份' + (index + 1) && soreType == 2 ? 'color:#910000' : ''
          "></i>
            </div>
          </div>

          <div class="title title-sbort" @click="handleSort('招生计划', soreType)">
            计划增减
            <div class="title-icon">
              <i class="el-icon-caret-top" :style="soreName == '招生计划' && soreType == 1 ? 'color:#910000' : ''"></i>
              <i class="el-icon-caret-bottom" :style="soreName == '招生计划' && soreType == 2 ? 'color:#910000' : ''"></i>
            </div>
          </div>
        </div>
      </div>
      <!--专业组---->
      <div class="tzy-container sbort_box" v-if="detail.listType && detail.listType == 3">
        <draggable v-model="sbortList" :options="dragOptions" @end="onEnd" :move="onMove" @start="onStart"
          :scroll="true" animation="300" :scroll-sensitivity="150" :force-fallback="true">
          <!-- 过度效果 -->
          <transition-group>
            <div class="h5-college-tr item" v-for="(item, index) in sbortList" :key="index">
              <div class="h5-major-tr flex" style="width: 100%">
                <div class="percent">
                  <div class="probab" @click="handleRanking(item, index)">
                    <div class="probab-logo">
                      <img data-v-05f84c54=""
                        src="data:image/png;base64,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"
                        alt="" />
                    </div>
                    <h1>
                      {{ index + 1 }}
                    </h1>
                  </div>
                  <div class="easy">
                    {{ item.probability }}
                    <span style="
                      font-size: 10px;
                      font-family: 'PingFang SC-Regular';
                      margin-left: -5px;
                    ">%</span>
                  </div>
                  <div class="tzy-chong-color three-frame">
                    <span v-if="item.riskLevel == '冲'" style="color: #e9302d">
                      {{ item.riskLevel }}
                    </span>
                    <span v-if="item.riskLevel == '稳'" style="color: #ff9a02">
                      {{ item.riskLevel }}
                    </span>
                    <span v-if="item.riskLevel == '保'" style="color: #06c687">
                      {{ item.riskLevel }}
                    </span>
                  </div>
                  <p>{{ item.riskDesc }}</p>
                </div>
                <div class="major">
                  <div class="major-info">
                    <p class="h5-major-tr_title mb6">
                      <a href="javascript:void(0)" class="f16 mt5">
                        <span class="collegeNamePreview" style="word-break: break-all">
                          <!-- {{ item.majorName }} -->
                          {{ item.collegeName }}
                          <span v-if="item.collegeMajorGroupName">
                            ({{ item.collegeMajorGroupName }})
                          </span>
                        </span>
                        <!-- <p style="font-size: 14px;color: #000;font-weight: normal;">
                          ({{ item.city }} {{ item.collegeCode }})
                        </p> -->
                        <!--10.注释专业-->
                        <!-- <section class="zy-remark">
                      {{ item.majorType }}
                    </section> -->
                        <p style="font-size: 12px; color: #9b9b9b; font-weight: normal;display: none;">
                          <!-- <span v-if="item.subjectReview"
                                    >学科评估 {{ item.subjectReview }}</span
                                  > -->
                          <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                        </p>
                      </a>
                    </p>
                  </div>
                  <!---->
                  <p class="mb6 fw500 college-code" style="display: none;">
                    <b class="pr10"> 专业代码 {{ item.majorEnrollCode }} </b><br />
                    <b class="mr10"> {{ item.year }}年计划 {{ item.planNum1 }}人 </b>
                    <span style="font-weight: normal">
                      {{ item.learnYear }} ¥{{ item.cost }}
                      <br />
                      <span class="mr10">
                        招生计划增减<span class="pl6">{{ item.planNumDiff > 0 ? '+' : ''
                          }}{{ item.planNumDiff }}</span>
                      </span>
                      选科 {{ item.chooseSubject }}
                    </span>
                  </p>
                  <div class="history-content history-conent" style="display: none;">
                    <table>
                      <tr>
                        <th width="40">年份</th>
                        <th width="60">录取人数</th>
                        <th width="50">最低分</th>
                        <th>最低位次</th>
                      </tr>
                      <tr v-if="item.minScore1">
                        <td align="center">{{ item.year }}</td>
                        <td align="center">{{ item.planNum1 }}</td>
                        <td align="center">{{ item.minScore1 }}</td>
                        <td align="center">{{ item.minRank1 }}</td>
                      </tr>
                      <tr>
                        <td align="center">{{ item.year - 1 }}</td>
                        <td align="center">{{ item.planNum2 }}</td>
                        <td align="center">{{ item.minScore2 }}</td>
                        <td align="center">{{ item.minRank2 }}</td>
                      </tr>
                      <tr>
                        <td align="center">{{ item.year - 2 }}</td>
                        <td align="center">{{ item.planNum3 }}</td>
                        <td align="center">{{ item.minScore3 }}</td>
                        <td align="center">{{ item.minRank3 }}</td>
                      </tr>
                      <tr v-if="!(item.minScore1)">
                        <td align="center">{{ item.year - 3 }}</td>
                        <td align="center">{{ item.planNum4 }}</td>
                        <td align="center">{{ item.minScore4 }}</td>
                        <td align="center">{{ item.minRank4 }}</td>
                      </tr>
                    </table>
                  </div>
                  <p class="mt5 mb4 fw500 majorNamePreview" style="display: none;">
                    <span @click="viewCollegeDetail(scope.row)">
                      {{ item.collegeName }}
                    </span>
                    {{ item.bzType }}
                  </p>
                  <p style="display: none;">
                    {{ item.province }} {{ item.city }} / {{ item.categories }} /
                    {{ item.natureType }} / 排名{{ item.collegeRank }}
                  </p>
                  <p class="fw500 college-code" style="display: none;">
                    大学代码 {{ item.collegeEnrollCode }}
                    <!-- <span class="mr10">{{ item.year }}年计划 {{ item.planNum1 }}人</span> -->
                  </p>
                </div>
                <div class="delete">
                  <span class="handle">☰</span>
                </div>
              </div>
              <!---->
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="tzy-container sbort_box" v-else>
        <draggable v-model="sbortList" :options="dragOptions" @end="onEnd" :move="onMove" @start="onStart"
          :scroll="true" animation="300" :scroll-sensitivity="150" :force-fallback="true">
          <!-- 过度效果 -->
          <transition-group>
            <div class="h5-college-tr item" v-for="(item, index) in sbortList" :key="index">
              <div class="h5-major-tr flex" style="width: 100%">
                <div class="percent">
                  <div class="probab" @click="handleRanking(item, index)">
                    <div class="probab-logo">
                      <img data-v-05f84c54=""
                        src="data:image/png;base64,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"
                        alt="" />
                    </div>
                    <h1>
                      {{ index + 1 }}
                    </h1>
                  </div>
                  <div class="easy">
                    {{ item.probability }}
                    <span style="
                      font-size: 10px;
                      font-family: 'PingFang SC-Regular';
                      margin-left: -5px;
                    ">%</span>
                  </div>
                  <div class="tzy-chong-color three-frame">
                    <span v-if="item.riskLevel == '冲'" style="color: #e9302d">{{
          item.riskLevel
        }}</span>
                    <span v-if="item.riskLevel == '稳'" style="color: #ff9a02">{{
          item.riskLevel
        }}</span>
                    <span v-if="item.riskLevel == '保'" style="color: #06c687">{{
          item.riskLevel
        }}</span>
                  </div>
                  <p>{{ item.riskDesc }}</p>
                </div>
                <div class="major">
                  <div class="major-info">
                    <p class="h5-major-tr_title mb6">
                      <a href="javascript:void(0)" class="f16 mt5">
                        <span class="collegeNamePreview" style="word-break: break-all">
                          {{ item.majorName }}
                        </span>
                        <!--10.注释专业-->
                        <!-- <section class="zy-remark">
                      {{ item.majorType }}
                    </section> -->
                        <p style="font-size: 12px; color: #9b9b9b; font-weight: normal">
                          <!-- <span v-if="item.subjectReview"
                                    >学科评估 {{ item.subjectReview }}</span
                                  > -->
                          <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                        </p>
                      </a>
                    </p>
                  </div>
                  <!---->
                  <p class="mb6 fw500 college-code">
                    <b class="pr10"> 专业代码 {{ item.majorEnrollCode }} </b><br />
                    <b class="mr10"> {{ item.year }}年计划 {{ item.planNum1 }}人 </b>
                    <span style="font-weight: normal">
                      {{ item.learnYear }} ¥{{ item.cost }}
                      <br />
                      <span class="mr10">
                        招生计划增减<span class="pl6">{{ item.planNumDiff > 0 ? '+' : ''
                          }}{{ item.planNumDiff }}</span>
                      </span>
                      选科 {{ item.chooseSubject }}
                    </span>
                  </p>
                  <div class="history-content history-conent">
                    <table>
                      <tr>
                        <th width="40">年份</th>
                        <th width="60">录取人数</th>
                        <th width="50">最低分</th>
                        <th>最低位次</th>
                      </tr>
                      <tr v-if="item.minScore1">
                        <td align="center">{{ item.year }}</td>
                        <td align="center">{{ item.planNum1 }}</td>
                        <td align="center">{{ item.minScore1 }}</td>
                        <td align="center">{{ item.minRank1 }}</td>
                      </tr>
                      <tr>
                        <td align="center">{{ item.year - 1 }}</td>
                        <td align="center">{{ item.planNum2 }}</td>
                        <td align="center">{{ item.minScore2 }}</td>
                        <td align="center">{{ item.minRank2 }}</td>
                      </tr>
                      <tr>
                        <td align="center">{{ item.year - 2 }}</td>
                        <td align="center">{{ item.planNum3 }}</td>
                        <td align="center">{{ item.minScore3 }}</td>
                        <td align="center">{{ item.minRank3 }}</td>
                      </tr>
                      <tr v-if="!(item.minScore1)">
                        <td align="center">{{ item.year - 3 }}</td>
                        <td align="center">{{ item.planNum4 }}</td>
                        <td align="center">{{ item.minScore4 }}</td>
                        <td align="center">{{ item.minRank4 }}</td>
                      </tr>
                    </table>
                  </div>
                  <p class="mt5 mb4 fw500 majorNamePreview">
                    <span @click="viewCollegeDetail(scope.row)">{{
          item.collegeName
        }}</span>
                    {{ item.bzType }}
                  </p>
                  <p>
                    {{ item.province }} {{ item.city }} / {{ item.categories }} /
                    {{ item.natureType }} / 排名{{ item.collegeRank }}
                  </p>
                  <p class="fw500 college-code">
                    大学代码 {{ item.collegeEnrollCode }}
                    <!-- <span class="mr10">{{ item.year }}年计划 {{ item.planNum1 }}人</span> -->
                  </p>
                </div>
                <div class="delete">
                  <span class="handle">☰</span>
                </div>
              </div>
              <!---->
            </div>
          </transition-group>
        </draggable>
      </div>

      <div class="foot-box van-row">
        <div class="recommendBtn-flex-flex">
          <button @click="clickReset" class="recommend-btn recommend-btn1">重置</button>
          <button @click="clickOk" class="recommend-btn">确认</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      detail: {},
      loading: false,
      apiObjDrag: {},
      tableData: [],
      tableDataBack: [],
      routerId: null,
      rankShow: false,
      rankData: null,
      rankNum: null,
      saveShow: false,
      removeData: [],
      sbortShow: false,
      sbortList: [],
      dragOptions: {
        animation: 400,
        group: "items",
        disabled: false,
        ghostClass: "ghost",
        handle: ".handle",
        sort: true,
        draggable: ".item",
        filter: ".ignore",
      },
      soreType: 0, //点击排序
      soreName: "", //点击排序
      soreNameBack: "", //点击排序
    };
  },
  async mounted() {
    const { query } = this.$router.currentRoute;
    //decodeURIComponent encodeURIComponent
    this.routerId = encodeURIComponent(query.id);
    console.log(this.routerId, "====roetr", this.$router.currentRoute);
    await this.userPlanlist();
  },

  destroyed() {
    //  localStorage.removeItem('savePlan')
  },
  methods: {
    //数据详情
    async userPlanlist() {
      let id = encodeURIComponent("Ti7e3wEx6s3WxDaZs¡+PVg==");
      const res = await this.$axios.get(`/php/user.plan.detail?id=` + this.routerId);
      console.log(222, res);
      if (res && res.data.ret == 0) {
        console.log(res.data.data);
        this.detail = res.data.data;

        this.tableData = res.data.data.planList;
        this.tableDataBack = res.data.data.planList;
      }

      // this.$nextTick(() => {
      //   this.rowDrop();
      // });
      console.log("===ssss", this.tableData);
    },
    format(percentage) {
      return percentage + "%" + "\n\n靠谱率";
    },
    //点击排序
    handleSort(name, type) {
      this.soreName = name;
      if (this.soreNameBack == "") {
        this.soreNameBack = name;
      }
      if (this.soreNameBack && this.soreNameBack != name) {
        this.soreType = 0;
        type = -1;
        this.soreNameBack = name;
      }
      let that = this;
      let dataList = that.sbortList.slice(0);
      if (type >= 2) {
        that.soreType = 0;
      } else {
        that.soreType = type + 1;
      }
      //院校
      if (name === "院校") {
        if (that.soreType == 0) {
          dataList = that.tableData;
        }
        if (that.soreType == 1) {
          dataList.sort(function (a, b) {
            if (a.collegeRank == b.collegeRank) {
              if (a.minScore1 == b.minScore1) {
                if (a.minScore2 == b.minScore2) {
                  return a.minScore3 - b.minScore3;
                }
                return a.minScore2 - b.minScore2;
              }
              return a.minScore1 - b.minScore1;
            }
            return a.collegeRank - b.collegeRank;
          });
        }
        if (that.soreType == 2) {
          dataList.sort(function (a, b) {
            if (a.collegeRank == b.collegeRank) {
              if (a.minScore1 == b.minScore1) {
                if (a.minScore2 == b.minScore2) {
                  return b.minScore3 - a.minScore3;
                }
                return b.minScore2 - a.minScore2;
              }
              return b.minScore1 - a.minScore1;
            }
            return b.collegeRank - a.collegeRank;
          });
        }
      }
      //年份1
      if (name === "年份1") {
        if (that.soreType == 0) {
          dataList = that.tableData;
        }
        if (that.soreType == 1) {
          dataList.sort(function (a, b) {
            if (a.minScore1 == b.minScore1) {
              if (a.minScore2 == b.minScore2) {
                return a.minScore3 - b.minScore3;
              }
              return a.minScore2 - b.minScore2;
            }
            return a.minScore1 - b.minScore1;
          });
        }
        if (that.soreType == 2) {
          dataList.sort(function (a, b) {
            if (a.minScore1 == b.minScore1) {
              if (a.minScore2 == b.minScore2) {
                return b.minScore3 - a.minScore3;
              }
              return b.minScore2 - a.minScore2;
            }
            return b.minScore1 - a.minScore1;
          });
        }
      }
      //年份2
      if (name === "年份2") {
        if (that.soreType == 0) {
          dataList = that.tableData;
        }
        if (that.soreType == 1) {
          dataList.sort(function (a, b) {
            if (a.minScore2 == b.minScore2) {
              return a.minScore3 - b.minScore3;
            }
            return a.minScore2 - b.minScore2;
          });
        }
        if (that.soreType == 2) {
          dataList.sort(function (a, b) {
            if (a.minScore2 == b.minScore2) {
              return b.minScore3 - a.minScore3;
            }
            return b.minScore2 - a.minScore2;
          });
        }
      }
      //年份3
      if (name === "年份3") {
        if (that.soreType == 0) {
          dataList = that.tableData;
        }
        if (that.soreType == 1) {
          dataList.sort(function (a, b) {
            // if (a.id == b.id) {
            //   return a.id - b.id;
            // }
            return a.minScore3 - b.minScore3;
          });
        }
        if (that.soreType == 2) {
          dataList.sort(function (a, b) {
            // if (a.id == b.id) {
            //   return a.id - b.id;
            // }
            return b.minScore3 - a.minScore3;
          });
        }
      }
      //招生计划
      if (name === "招生计划") {
        if (that.soreType == 0) {
          dataList = that.tableData;
        }
        if (that.soreType == 1) {
          dataList.sort(function (a, b) {
            if (a.planNumDiff == b.planNumDiff) {
              if (a.minScore1 == b.minScore1) {
                if (a.minScore2 == b.minScore2) {
                  return a.minScore3 - b.minScore3;
                }
                return a.minScore2 - b.minScore2;
              }
              return a.minScore1 - b.minScore1;
            }
            return a.planNumDiff - b.planNumDiff;
          });
        }
        if (that.soreType == 2) {
          dataList.sort(function (a, b) {
            if (a.planNumDiff == b.planNumDiff) {
              if (a.minScore1 == b.minScore1) {
                if (a.minScore2 == b.minScore2) {
                  return b.minScore3 - a.minScore3;
                }
                return b.minScore2 - a.minScore2;
              }
              return b.minScore1 - a.minScore1;
            }
            return b.planNumDiff - a.planNumDiff;
          });
        }
      }
      that.sbortList = dataList;
      console.log(
        dataList[0].majorName,
        "====handleSort",
        that.soreType,
        this.soreNameBack,
        name
      );
    },
    //行-拖拽
    rowDrop() {
      const tbody = document.querySelector(".table-content ");
      const _this = this;
      Sortable.create(".tzy-container", {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
          //   拖动后获取newIdex
          let arr = Array.from(_this.tableData);
          _this.apiObjDrag = arr.map((item, index) => {
            return {
              id: item.id,
              dictSort: index,
            };
          });
        },
      });
    },
    async edit() {
      //accounts/fill?bzType=本科&course=物理&id=10&majorBzType=ben&score=362
      let arr = [];
      if (this.detail.listType && this.detail.listType == 2) {
        this.tableData.map((e) => {
          arr = arr.concat(e.majors);
        });
      } else if (this.detail.listType && this.detail.listType == 3) {
        this.tableData.map((e) => {
          arr = arr.concat(e.majors);
        });
      } else {
        arr = this.tableData;
      }
      this.$store.commit("setPlan", arr);
      console.log("=====修改", arr);
      this.$router.push(
        `/accounts/fill?accounts/fill?bzType=${this.detail.userScore.bzType}&course=${this.detail.userScore.course}&id=${this.detail.pcId}&score=${this.detail.userScore.score}&editId=${this.routerId}`
      );
    },
    async save() {
      console.log(this.tableData);
      const { query } = this.$router.currentRoute;
      let id = encodeURIComponent(encodeURIComponent(query.id));
      console.log(this.routerId, "====roetr", id);
      const res = await this.$axios.post("/php/user.plan.update", {
        id: this.routerId,
        plan: this.tableData.map((e) => e.id),
      });
      console.log(res);
      if (res && res.data.ret === 0) {
        this.saveShow = true;
        this.$message({
          message: "保存成功",
          type: "success",
        });
      } else {
        this.$message({
          message: "保存失败",
          type: "fail",
        });
      }
    },
    print() {
      window.print();
    },
    download() {
      window.open(`/php/user.plan.export?id=${this.routerId}`);
    },
    del(row, listType, num) {
      this.$confirm("删除该专业, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        if (num >= 0) {
          this.tableData[num].majors = this.tableData[num].majors.filter((e) => e.id !== row.id);
          // this.removeData[num].majors = this.tableData[num].majors.map((e) => {
          //   return e.id;
          // });
        } else {
          if (listType == 'listType3') {
            this.tableData = this.tableData.filter((e) => e.collegeMajorGroupCode !== row.collegeMajorGroupCode);
            // this.removeData = this.tableData.map((e) => {
            //   return e.collegeMajorGroupCode;
            // });
          } else {
            this.tableData = this.tableData.filter((e) => e.id !== row.id);
            this.removeData = this.tableData.map((e) => {
              return e.id;
            });
          }
        }
        setTimeout(() => {
          this.$toast("删除成功！");
        }, 500);
      });

      console.log("==this.removeData", this.removeData);

      this.$forceUpdate();
      // this.compareCollegeList = _.without(this.compareCollegeList, data);
      //   this.checkedColleges = _.without(this.checkedColleges, data);
    },
    rank(name, item, index, listType, num) {
      console.log(name, index, "===设置排名item", item, num);
      if (name == "up") {
        index -= 1;
      } else {
        index += 1;
      }

      if (num >= 0) {
        let list = this.tableData[num].majors.filter((e) => e.id !== item.id);
        console.log(index, "====设置排名1----------", list);
        // list[index]=this.rankData

        list.splice(index, 0, item);
        console.log(index, "====设置排名2------", list);
        this.tableData[num].majors = list;
        this.$forceUpdate();
      } else {
        if (listType == 'listType3') {
          let list = this.tableData.filter((e) => e.collegeMajorGroupCode !== item.collegeMajorGroupCode);
          console.log(index, "====设置排名1---listType3", list);
          // list[index]=this.rankData

          list.splice(index, 0, item);
          console.log(index, "====设置排名2---listType3", list);
          this.tableData = list;
        } else {
          let list = this.tableData.filter((e) => e.id !== item.id);
          console.log(index, "====设置排名1", list);
          // list[index]=this.rankData

          list.splice(index, 0, item);
          console.log(index, "====设置排名2", list);
          this.tableData = list;
        }
      }
      this.$forceUpdate();
    },
    //排名
    handleRanking(item, num) {
      this.rankShow = true;
      this.rankData = item;
      this.rankNum = num;
    },
    //设置排名
    setRanking(item, index) {
      console.log("===设置排名item", item);
      this.rankShow = false;
      let list = this.tableData.filter((e) => e.id !== this.rankData.id);
      console.log(index, "====设置排名1", list);
      // list[index]=this.rankData
      list.splice(index, 0, this.rankData);
      console.log(index, "====设置排名2", list);
      this.tableData = list;
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    clickReset() {
      this.soreType = 0;
      this.soreNameBack = "";
      this.sbortList = this.tableData;
    },
    clickOk() {
      this.sbortShow = false;
      this.tableData = this.sbortList;
    },
    handleSbort() {
      this.sbortShow = true;
      this.sbortList = this.tableData;
      this.soreType = 0;
      this.soreNameBack = "";
    },
    onEnd(evt) {
      console.log("onEnd", evt);
    },
    onMove(evt) {
      console.log("onMove", evt);
    },
    onStart(evt) {
      console.log("onStart", evt);
    },
    dragover(evt) {
      console.log("dragover", evt);
    },
  },
};
</script>

<style lang="scss" scoped>
.table-content {
  padding: 0 15px 40px;
}

.tzy-container {
  // min-height: calc(100vh - 310px);
  // padding-top: 12px;
  // padding-bottom: 10px;
  background: #f8f5f4;

  // padding-left: 12px;
  // padding-right: 12px;
  .pl0 {
    padding-left: 0 !important;
  }

  .pb0 {
    padding-bottom: 0 !important;
  }

  .flex {
    display: flex;
  }

  .h5-college-tr {
    background: #fff;
    background: linear-gradient(#fff5ef, #fff 112px);
    padding-right: 10px;
    padding-left: 10px;
    // padding-bottom: 15px;
    margin-bottom: 10px;
    border-radius: 8px;
    border: 1px solid #fff;
  }

  .h5-college-tr .college-action {
    min-width: 10%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .h5-college-tr .college-action i {
    font-size: 22px;
  }

  .h5-college-tr .college-action i.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }

  .h5-college-tr .college-action .el-icon-delete {
    margin: 5px 0;
    font-size: 16px;
  }

  .h5-college-tr .h5-major-tr_title {
    margin-bottom: 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .h5-college-tr .h5-major-tr_title>a {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    line-height: 22px;
    color: #000;
    font-weight: 600;
  }

  .h5-college-tr .h5-major-tr_title>span {
    margin-left: 4px;
  }

  .h5-college-tr .percent {
    display: -webkit-box;
    padding-right: 12px;
    padding-left: 2px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
  }

  .h5-college-tr .percent .probab {
    position: relative;
    width: 32px;
    height: 30px;
    font-size: 14px;
    font-family: Bebas;
    color: #fff;
  }

  .h5-college-tr .percent .probab .probab-logo,
  .h5-college-tr .percent .probab .probab-logo img {
    width: 100%;
  }

  .h5-college-tr .percent .probab h1 {
    display: block;
    position: absolute;
    top: 6px;
    left: 4px;
    min-width: 25px;
    font-size: 14px;
    font-family: Bebas;
    color: #fff;
    letter-spacing: 0;
    line-height: 14px;
    text-align: center;
  }

  .easy {
    min-width: 32px;
    width: auto;
    text-align: center;
    font-size: 16px;
    font-family: Bebas;
    color: #333;
    font-weight: bold;
    padding-top: 4px;
  }

  .majorNamePreview {
    font-weight: 800;
    font-size: 16px;
    color: #333;
    padding: 5px 0;
  }

  .h5-college-tr .percent p {
    font-size: 12px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 10px;
    color: #999;
    letter-spacing: 0;
    text-align: center;
    -webkit-transform: scale(0.83);
    transform: scale(0.83);
    margin-top: 3px;
  }

  .h5-college-tr .percent .recommend-type {
    height: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
    font-size: 12px;
  }

  .h5-college-tr .percent .recommend-type span {
    display: inline-block;
    border: 1px solid #fff;
    min-width: 40px;
    max-width: 100px;
    text-align: center;
    border-radius: 4px;
    padding: 4px 0;
  }

  .h5-college-tr .percent .recommend-type .chong {
    color: #910000;
    border-color: #910000;
  }

  .h5-college-tr .percent .recommend-type .wen {
    color: #ff9a02;
    border-color: #ff9a02;
  }

  .h5-college-tr .percent .recommend-type .bao {
    color: #0c3;
    border-color: #0c3;
  }

  .h5-college-tr .college {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin-top: 15px;
    font-size: 12px;
    color: #999;
    letter-spacing: 0;
    line-height: 20px;
    word-break: break-all;
  }

  .h5-college-tr .college .college-info>div {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .h5-college-tr .college .college-info>div>p {
    color: #999;
  }

  .h5-college-tr .college .college-info a {
    display: inline-block;
    line-height: 18px;
    font-size: 16px;
    letter-spacing: 0;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #000;
    margin-bottom: 6px;
  }

  .h5-college-tr .college .college-intr {
    color: #666;
  }

  .college-code {
    color: #333;
  }

  .fw500 {
    font-weight: 500;
  }

  .h5-college-tr .college .plan {
    color: #333;
    margin-bottom: 8px;
  }

  .h5-college-tr .major {
    padding-top: 16px;
    padding-bottom: 15px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 12px;
    color: #666;
    letter-spacing: 0;
    line-height: 20px;
    word-break: break-all;
  }

  .h5-college-tr .major .college-info a {
    line-height: 24px;
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
  }

  .h5-college-tr .major .major-info a {
    line-height: 24px;
    font-size: 16px;
    color: #212121;
    letter-spacing: 0;
  }

  .h5-college-tr .three-one-two-history .tabs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }

  .h5-college-tr .three-one-two-history .tabs>span {
    cursor: pointer;
  }

  .h5-college-tr .filter,
  .h5-college-tr .filter .iconfont {
    font-size: 12px;
  }

  .h5-college-tr .profession-count-button {
    display: inline-block;
    height: 28px;
    line-height: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    min-width: 56px;
    border: 1px solid #ccc;
    border-radius: 14px;
    font-size: 12px;
    letter-spacing: 0;
  }

  .h5-college-tr .profession-count-button {
    color: #910000;
    border: 1px solid #910000;
  }

  .h5-college-tr .fav {
    vertical-align: bottom;
    display: inline-block;
    text-align: center;
    overflow: hidden;
    width: 20px;
    height: 20px;
    margin-bottom: 4px;
    border-radius: 50%;
  }

  .h5-college-tr .fav .iconfont {
    vertical-align: super;
    color: #ed4c4a;
    font-size: 14px;
  }

  .h5-college-tr .three-frame {
    margin-top: 8px;
    width: 30px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: 14px;
  }

  .h5-college-tr .h5-default-table {
    color: #666;
    font-size: 12px;
    line-height: 22px;
  }

  .h5-college-tr .h5-major-tr.dialog {
    background: #fff;
    background: linear-gradient(#ff4343, #fff 112px);
    border: 1px solid #fff;
    border-radius: 8px;
    padding-top: 15px;
    padding-bottom: 16px;
    margin-bottom: 10px;
    padding-right: 12px;
    font-size: 12px;
    color: #666;
    letter-spacing: 0;
  }

  .h5-college-tr .h5-major-tr .percent h1 {
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    font-family: Bebas;
    color: #fff;
    line-height: 14px;
    white-space: nowrap;
  }

  .h5-college-tr .h5-major-tr .percent p {
    padding-bottom: 10px;
    font-size: 12px;
    letter-spacing: 0;
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999;
    line-height: 10px;
  }

  .h5-college-tr .h5-major-tr .major-info {
    line-height: 20px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .h5-college-tr .h5-major-tr .major-info a {
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
  }

  .h5-college-tr .h5-major-tr .major-info .h5-major-tr_match {
    color: #999;
  }

  .h5-college-tr .h5-major-tr .major-info .h5-major-tr_code {
    margin-bottom: 8px;
    color: #333;
  }

  .h5-college-tr .h5-major-tr .major-action {
    min-width: 10%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .h5-college-tr .h5-major-tr .major-action i {
    font-size: 22px;
  }

  .h5-college-tr .h5-major-tr .major-action i.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }

  .h5-college-tr .h5-major-tr .major-action .el-icon-delete {
    margin: 5px 0;
    font-size: 14px;
  }

  .h5-college-tr .h5-major-tr .van-overlay {
    background-color: rgba(0, 0, 0, 0.2) !important;
  }

  .h5-college-tr .tzy-sort {
    float: left;
    width: 30px;
    height: 30px;
    line-height: 30px;
    color: #666;
    border: 1px solid #9b9b9b;
    text-align: center;
    margin-left: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
  }

  .delete {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    width: 30px;
    align-content: center;
    justify-content: center;

    .icon-item {
      font-size: 30px;
    }

    .icon-item:nth-child(2) {
      padding: 10px 0;
      font-size: 20px;
    }
  }
}

.major_title {
  font-family: PingFangSC-Medium, PingFang SC;
  color: #333;
  padding: 20px 16px;
  background: #fff;
  line-height: 24px;

  div {
    font-size: 22px;
  }

  p {
    font-size: 16px;
  }
}

.major_cont {
  overflow-y: auto;

  // height: 69vh;
  .num {
    display: block;
    width: 100%;
    padding: 14px 16px;
    font-size: 16px;
    background-color: #fff;
    border: none;
    cursor: pointer;
    margin-bottom: 11px;
    border-radius: 5px;
    text-align: center;
  }

  .num.active {
    font-weight: bold;
    color: #910000;
  }
}

.home_page1 {
  padding-top: 132px;
}

.detail_box {
  position: fixed;
  top: 0;
  width: 87%;
  z-index: 99;
}

.info_nav {
  display: flex;
  align-items: center;
  // width: 100%;
  background: #fff;
  height: 50px !important;
  border-bottom: none;
  justify-content: space-between;

  div {
    color: #333;
    font-size: 14px;
    margin-right: 5px;
    font-weight: 800;
  }

  .back {
    color: #333;
    font-size: 18px;
    font-weight: 800;
    margin-right: 8px;
    padding-left: 15px;
  }
}

.header_all {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0 20px 15px;
  font-size: 14px;
  font-weight: 700;
  width: 100vw;
  position: absolute;
  top: 50px;
  justify-content: space-between;

  .sbort {
    font-size: 12px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    background: linear-gradient(307deg, #910000, #c72b2b);
    border-radius: 23px;
    padding: 4px 17px;
  }
}

.foot-box {
  position: fixed;
  bottom: 0;
  left: 0;
  padding-left: 0;
}

.text-flex {
  width: 143px;
}

.foot-box {
  z-index: 44;
  width: 100vw;
  height: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
  border-top: 1px solid #ddd;
}

.foot-box button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #910000;
  border-color: #910000;
  height: 40px;
}

.foot-box .recommendBtn-flex-flex {
  // -webkit-box-flex: 2;
  // -ms-flex: 2;
  // flex: 2;
  // display: -webkit-box;
  // display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  padding-left: 15px;
  padding-right: 15px;
}

.foot-box .recommendBtn-flex-flex .recommend-btn {
  width: 100%;
  border-radius: 20px;
  color: #fff;
  font-size: 16px;
}

.foot-box .recommendBtn-flex-flex .recommend-btn1 {
  width: 60%;
  border-radius: 20px;
  color: #910000;
  font-size: 16px;
  background: #fff;
  border: 1px solid #910000;
  margin-right: 10px;
}

.zyb-page-refactor .prompt .cbw {
  width: auto;
  height: 52px;
  padding-right: 11px;
  background: #f8f5f4;
}

.cbw_all {
  display: flex;
  align-items: center;
  justify-content: end;
  height: 50px;
  background: #f1f1f1;
  width: 100vw;
  position: absolute;
  top: 84px;

  .tisi {
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }

  .tisi .cbw-li {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-transform: translate(-50deg);
    transform: translate(-50deg);
  }

  .tisi .cbw-li div {
    font-size: 14px;
    margin-right: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 18px;
  }

  .tisi .cbw-li .rush {
    background-color: #e9302d;
  }

  .tisi .cbw-li .stable {
    background-color: #ff9a02;
  }

  .tisi .cbw-li .protect {
    background-color: #0c3;
  }

  .tisi .cbw-li .round {
    width: 11px;
    height: 11px;
    border-radius: 11px;
    margin-right: 5px;
  }
}

.tip_box {
  padding: 0 25px 25px;
  line-height: 28px;
  font-size: 16px;

  .tip_box_title {
    line-height: 60px;
    font-weight: bold;
    font-size: 20px;

    i {
      padding-right: 8px;
      vertical-align: baseline;
    }
  }

  .tip_box_btn {
    width: 100%;
    border-radius: 20px;
    color: #fff;
    font-size: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #910000;
    border-color: #910000;
    height: 40px;
    margin: 30px auto 0;
  }
}

.sbort_box {
  padding: 114px 15px 60px;
  overflow-y: auto;
  max-height: 85vh;

  .ghost {
    opacity: 0.5;
    background-color: #ccc;
  }

  .handle {
    cursor: move;
    user-select: none;
    display: inline-flex;
    align-items: center;
    font-size: 28px;
  }

  .ignore {
    pointer-events: none;
  }
}

.sbort_header {
  padding: 30px 15px 10px;
  position: fixed;
  width: 100%;
  background: #fff;
  z-index: 1;
  border-bottom: 10px solid #f2f2f2;

  .sbort_box_title {
    display: flex;
    align-items: center;

    .fast-queue {
      min-width: 64px;
      height: 26px;
      color: #212121;
      line-height: 26px;
      margin-left: 15px;
      font-weight: 600;
      font-size: 16px;
    }

    .order {
      // width: 84px;
      height: 18px;
      font-size: 11px;
      color: #9b9b9b;
      line-height: 18px;
      margin-left: 8px;
      vertical-align: middle;
    }
  }

  .popup-title {
    display: flex;
    padding: 8px 12px 0px;
    font-size: 13px;

    color: #222;

    .title-icon {
      padding: 0 5px 8px 0;
    }

    .title {
      display: flex;
      align-items: center;
      white-space: nowrap;
      line-height: 1;
      text-align: center;

      .title-icon {
        width: 20px;
        display: inline-flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 0;

        i:nth-child(2) {
          margin-top: -8px;
        }
      }

      .fen {
        font-size: 12px;
        color: #910000;
      }
    }
  }
}

.major table {
  margin-left: -10px;
}
</style>
